import React from 'react'
import { CircleIconButton } from '@/components/CircleIconLink'
import classNames from 'classnames'

interface Props {
  isExpanded: boolean
  onClick?: () => void
}

const ToggleArcadeValuesButton = ({ onClick, isExpanded }: Props) => {
  return (
    <CircleIconButton
      className={classNames({
        'bg-white text-gray-900 flex-shrink-0': isExpanded
      })}
      size="md"
      name="coinStack"
      onClick={onClick}
    />
  )
}

export default ToggleArcadeValuesButton
